module.exports = __webpack_public_path__ + "static/media/map-default.cc086746.png";